import {ArrowRight, Bot, Search} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const STATS = [
  { value: '16', label: 'проектов в активной работе' },
  { value: '100+', label: 'проверенных гипотез роста' },
  { value: '2', label: 'канала: поиск и нейросети' },
]

function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-neutral-950 pt-16 sm:pt-20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,rgba(52,211,153,0.16),transparent)]" />
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:56px_56px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,black,transparent)]" />

      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
        <FadeIn className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-neutral-800 bg-neutral-900/60 px-4 py-1.5 text-xs font-medium text-emerald-300">
            <Search className="h-3.5 w-3.5" />
            SEO-продвижение
            <span className="text-neutral-600">+</span>
            <Bot className="h-3.5 w-3.5" />
            GEO-продвижение
          </span>

          <h1 className="mt-6 text-4xl font-black leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Выводим бизнес в топ поиска —
            {' '}
            <span className="text-emerald-400">и в ответы нейросетей</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-400 sm:text-lg">
            Классическое SEO-продвижение в Яндекс и Google плюс GEO-оптимизация для
            ChatGPT, Perplexity, Gemini, DeepSeek и Алисы. Через рост видимости —
            к росту заявок и продаж вашего бизнеса.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#contact"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-emerald-400 px-6 py-3 text-sm font-semibold text-neutral-950 transition-colors hover:bg-emerald-300"
            >
              Оставить заявку
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="#what"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-neutral-700 px-6 py-3 text-sm font-semibold text-neutral-200 transition-colors hover:border-neutral-500 hover:text-white"
            >
              Что такое SEO и GEO
            </a>
          </div>
        </FadeIn>

        <FadeIn delay={150} className="mx-auto mt-16 max-w-3xl">
          <dl className="grid grid-cols-1 gap-6 sm:grid-cols-3">
            {STATS.map(stat => (
              <div
                key={stat.label}
                className="rounded-2xl border border-neutral-800 bg-neutral-900/40 px-6 py-6 text-center"
              >
                <dd className="font-mono text-3xl font-bold text-emerald-400">{stat.value}</dd>
                <dt className="mt-2 text-sm text-neutral-400">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </FadeIn>
      </div>
    </section>
  )
}

export default Hero
